import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowTrendUp } from "react-icons/fa6";
import DjSearch from "./DjSearch";
import IndustryCarousel from "./IndustryCarousel";
import SavedTalentRow from "./SavedTalentRow";
import { t } from "../i18n";

// The Browse screen's content, shared by the fan Browse tab (pages/
// FanHomePage) and the talent's Discover sheet (1.5.3, components/
// DiscoverSheet): the "Find an Artist or Venue" line, the search field, the
// "Trending" carousel and the "Saved" row (hidden while empty). The
// styles are the Browse tab's (.fanhome-*, pages/FanHomePage.css); the sheet
// adds its own touches on top.
//
// Every talent opens the same way: their fan page, carrying fromBrowse so it
// shows a back arrow. `onOpen` lets Discover open them its own way.

type Props = { onOpen?: (slug: string) => void };

export default function BrowseBody({ onOpen }: Props) {
  const navigate = useNavigate();
  const open = onOpen ?? ((slug: string) => navigate(`/${slug}`, { state: { fromBrowse: true } }));
  return (
    <>
      {/* Context line above the bar (founder decision): says what the search IS. */}
      <h2 className="fanhome-search-label">{t("fanHomePage.searchAnArtistBy")}</h2>
      <DjSearch alwaysOpen onOpen={onOpen} />
      <h2 className="fanhome-row-label">
        <FaArrowTrendUp size={16} aria-hidden />
        <span>{t("fanHomePage.trending")}</span>
      </h2>
      {/* Full-bleed strip — escapes the page padding so cards glide edge
          to edge like the landing page. */}
      <div className="fanhome-carousel">
        <IndustryCarousel onOpen={onOpen} />
      </div>
      <SavedTalentRow onOpen={open} />
    </>
  );
}
